import React, { useState } from "react";
import { useStore } from "store";
import { useWindowDimensions } from "resources/BrowserManager";
import CONSTANTS from "shared/constants";
import strings from "resources/strings";
import { Flex, Typography, Button, Modal, Input, message } from "antd";
const { Text } = Typography;
import { GiftOutlined } from "@ant-design/icons";

import ApiManager from "resources/ApiManager/api";

import "./style.scss";

function ModalAccountDelete({ openTitle }) {
  const { isSmallView } = useWindowDimensions();

  const setUser = useStore((state) => state.setUser);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHandlingRequest, setIsHandlingRequest] = useState(false);
  const [InputValue, setInputValue] = useState(null);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsHandlingRequest(false);
    setIsModalOpen(false);
    setInputValue(null);
  };

  const handleOk = async () => {
    //Call server
    setIsHandlingRequest(true);
    const apiRes = await ApiManager.postUserCreditCoupon(InputValue);
    setIsHandlingRequest(false);

    //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
    if (apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED) {
      return;
    }

    if (apiRes.response.code === 3003) {
      message.error(strings.alertCreditCouponInvalid);
      return;
    } else if (apiRes.response.code === 3004) {
      message.warning(strings.alertCreditCouponAlreadyApplied);
      return;
    } else if (apiRes.response.code === 3005) {
      message.warning(strings.alertCreditCouponClassAlreadyApplied);
      return;
    } else if (apiRes.response.code !== 2000) {
      message.error(strings.alertUnexpectedError);
      return;
    }

    //update user
    const user = apiRes.data;
    setUser(user);

    message.success(strings.alertCreditCouponOk, 10);
    handleCancel();
  };

  const onInputChange = (e) => {
    setInputValue(e.target.value.toUpperCase());
  };

  return (
    <>
      <Button
        icon={<GiftOutlined />}
        onClick={showModal}
        style={{ minWidth: "150px" }}
      >
        {openTitle}
      </Button>

      <Modal
        title={openTitle}
        open={isModalOpen}
        onCancel={handleCancel}
        width={560}
        destroyOnClose={true}
        footer={null}
        maskClosable={!isHandlingRequest}
        closable={!isHandlingRequest}
      >
        <Flex vertical gap={20}>
          <Text>Introduce el código del cupón que deseas aplicar.</Text>

          <Flex gap={20} vertical={isSmallView}>
            <Flex justify="center">
              <Input
                maxLength={20}
                disabled={isHandlingRequest}
                style={{
                  width: "300px",
                }}
                onInput={onInputChange}
                value={InputValue}
                onPressEnter={handleOk}
              />
            </Flex>
          </Flex>

          <Flex justify="flex-end" gap={10}>
            <Button
              type="primary"
              loading={isHandlingRequest}
              onClick={handleOk}
              disabled={!!!InputValue}
            >
              {openTitle}
            </Button>
            <Button danger disabled={isHandlingRequest} onClick={handleCancel}>
              Cancelar
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
}

export default ModalAccountDelete;
